import React, { FunctionComponent } from "react";

import "./design-token-color.scss";

interface DesignTokenColorProps {
    alpha?: number;
    color: string;
    name: string;
}

const copyColorCodeToClipboard = (colorValue: string): void => {
    // There's no success or error message. This feature is convenient for development,
    // but we shouldn't promote copy/pasting color values across our products.
    navigator.clipboard.writeText(colorValue);
};

export const DesignTokenColor: FunctionComponent<DesignTokenColorProps> = ({
    alpha,
    color,
    name
}: DesignTokenColorProps) => (
    <span
        className="epi-ds-site-design-token-color"
        title={color}
        onClick={() => copyColorCodeToClipboard(color)}
    >
        <span
            className="epi-ds-site-design-token-color--box"
            style={{
                background: color,
                opacity: alpha
            }}
        />
        {/* Borrow the "language-text" class from Gatsby's default <code> styling. */}
        <code className="language-text">
            {name}
        </code>
    </span>
);
